<template>
  <div class="card">
    <div class="card-header">
      <h5>Установка таймера активации препарата</h5>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label>Причина деактивации</label>
        <input type="text" class="form-control" v-model="comment">
      </div>
      <div class="form-group">
        <label>
          <input type="checkbox" v-model="change_slug"> сменить URL препарата на сайте
        </label>
      </div>
      <div class="form-group">
        <label>Дата активации</label>
        <DateSelectProps
          ref="selectedDate"
          :disabled="true"
        />
      </div>
      <div class="mt-1 text-right">
        <LoadingButton
          title='Сохранить'
          type="button"
          :loading="btnLoading"
          :color="$constants.PRIMARY_COLOR"
          :onClick="() => saveRecord()"
          className="btn btn-outline-info"
        />
      </div>
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DateSelectProps from "@/views/reports/components/DateSelectProps.vue";
import api from "@/api";

export default {
  components: {DateSelectProps, LoadingButton},
  props: ['drug'],
  data() {
    return {
      btnLoading: false,
      change_slug: false,
      comment: '',
    }
  },
  methods: {
    async saveRecord() {
      this.btnLoading = true;
      const {data} = await api.post('/tasks/new', {
        type: 'activation_drug_delay',
        drug_id: this.drug.id,
        comment: this.comment,
        change_slug: this.change_slug,
        date: this.$refs.selectedDate.date,
      })
      if (data.success) {
        toastr.success('Успешно сохранено');
        this.$store.dispatch('platform/setGlobalDrawerData', null);
      } else {
        toastr.error('Ошибка сохранения');
      }
      this.btnLoading = false;
    }
  }
}

</script>
